// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___84433fd0b62031c7e0d{/*!*/}.Unibrow-cls2___e899d996d22e145b6cc{position:absolute;top:0;right:0;width:36px;height:36px;display:flex;align-items:center;justify-content:center;color:inherit;cursor:pointer;opacity:.8}.Unibrow-cls2___e899d996d22e145b6cc:hover{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___84433fd0b62031c7e0d",
	"cls2": "Unibrow-cls2___e899d996d22e145b6cc Unibrow-cls1___84433fd0b62031c7e0d"
};
export default ___CSS_LOADER_EXPORT___;
